/**
 * SideNavLink.tsx — lenke i side-nav
 *
 * Ren React-komponent som erstatter cds-side-nav-link.
 * Bruker next/link for ruting. Active-state markerer gjeldende rute.
 *
 * Props:
 * - href: rute-lenke
 * - active: om lenken er aktiv
 * - children: lenketekst
 */

import Link from 'next/link';
import styles from './side-nav-link.module.css';

interface SideNavLinkProps {
  href: string;
  active?: boolean;
  children: React.ReactNode;
}

export default function SideNavLink({ href, active = false, children }: SideNavLinkProps) {
  return (
    <li className={styles.item}>
      <Link
        href={href}
        className={active ? styles.linkActive : styles.link}
        aria-current={active ? 'page' : undefined}
      >
        {/* side-nav-text: global klasse — skjules i kollapset rail-modus
            (se side-nav.module.css, lg+ media query) */}
        <span className="side-nav-text">{children}</span>
      </Link>
    </li>
  );
}
